//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { IReportStudentIDsInputItem } from './IReportStudentIDsInputItem';
import { PracticeLogSummaryReportSortBy, ReportType } from './Enums';

export class PracticeLogSummaryReportInputItem extends ReportInputItem implements IReportDateRangeInputItem, IReportStudentIDsInputItem {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    StudentIDs: string[] = [];
    SortBy: PracticeLogSummaryReportSortBy = PracticeLogSummaryReportSortBy.NumberOfEntries;
    override readonly Type: ReportType = ReportType.PracticeSummary;

    constructor(initializer?: Partial<Omit<PracticeLogSummaryReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "PracticeLogSummaryReportInputItem";
}
